import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import { formatCompact, formatINR, formatPct } from "@/lib/format";

export function CategoryTab({ calc }) {
  const cats = calc.categories;
  if (!cats.length) return <p className="text-sm text-slate-500" data-testid="categories-empty">No items to group yet.</p>;
  return (
    <div className="space-y-6">
      <div className="bg-white border border-slate-200 rounded-sm shadow-sm p-5">
        <h3 className="font-heading text-lg font-bold text-slate-900">Profit / Loss by Category</h3>
        <div className="h-72 mt-4" data-testid="category-profit-chart">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={cats.map((c) => ({ name: c.category, Profit: Math.round(c.profit) }))} layout="vertical" margin={{ left: 20, right: 20 }}>
              <CartesianGrid stroke="#E2E8F0" horizontal={false} />
              <XAxis type="number" tickFormatter={(v) => formatCompact(v).replace("₹", "")} tick={{ fontSize: 11, fill: "#64748B" }} />
              <YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 11, fill: "#334155" }} />
              <Tooltip formatter={(v) => formatINR(v)} contentStyle={{ borderRadius: 2, fontSize: 12 }} />
              <Bar dataKey="Profit" radius={[0, 2, 2, 0]}>
                {cats.map((c) => <Cell key={c.category} fill={c.profit >= 0 ? "#059669" : "#E11D48"} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="w-full overflow-x-auto rounded-sm border border-slate-200 bg-white" data-testid="category-table">
        <table className="w-full text-left border-collapse text-sm">
          <thead>
            <tr>
              {["Category", "Items", "Govt Amount", "Revenue", "Expenditure", "Profit / Loss", "Margin"].map((h, i) => (
                <th key={h} className={`bg-slate-50 text-xs font-semibold text-slate-500 uppercase tracking-wider p-3 border-b border-slate-200 ${i ? "text-right" : ""}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cats.map((c) => (
              <tr key={c.category} className="hover:bg-slate-50 transition-colors" data-testid={`category-row-${c.category.replace(/\s+/g, "-").toLowerCase()}`}>
                <td className="p-3 border-b border-slate-100 font-medium text-slate-800 whitespace-nowrap">{c.category}</td>
                <td className="p-3 border-b border-slate-100 text-right tabular">{c.count}</td>
                <td className="p-3 border-b border-slate-100 text-right tabular whitespace-nowrap">{formatINR(c.govtAmount)}</td>
                <td className="p-3 border-b border-slate-100 text-right tabular whitespace-nowrap">{formatINR(c.revenue)}</td>
                <td className="p-3 border-b border-slate-100 text-right tabular whitespace-nowrap">{formatINR(c.expenditure)}</td>
                <td className={`p-3 border-b border-slate-100 text-right tabular font-semibold whitespace-nowrap ${c.profit >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{formatINR(c.profit)}</td>
                <td className={`p-3 border-b border-slate-100 text-right tabular ${c.profit >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{formatPct(c.margin)}</td>
              </tr>
            ))}
            <tr className="bg-slate-900 text-white font-semibold">
              <td className="p-3">Total</td>
              <td className="p-3 text-right tabular">{calc.itemCount}</td>
              <td className="p-3 text-right tabular whitespace-nowrap">{formatINR(calc.govtAmount)}</td>
              <td className="p-3 text-right tabular whitespace-nowrap">{formatINR(calc.revenue)}</td>
              <td className="p-3 text-right tabular whitespace-nowrap">{formatINR(calc.expenditure)}</td>
              <td className={`p-3 text-right tabular whitespace-nowrap ${calc.profit >= 0 ? "text-emerald-300" : "text-rose-300"}`}>{formatINR(calc.profit)}</td>
              <td className="p-3 text-right tabular">{formatPct(calc.margin)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
